/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     #regionMap .africa, [_nghost-%COMP%]     #regionMap .asia, [_nghost-%COMP%]     #regionMap .caribbean, [_nghost-%COMP%]     #regionMap .europe, [_nghost-%COMP%]     #regionMap .latinamerica, [_nghost-%COMP%]     #regionMap .middleeast, [_nghost-%COMP%]     #regionMap .northamerica, [_nghost-%COMP%]     #regionMap .pacificrim{opacity:0}"];
export { styles as styles };
